import React from 'react';
import cx from 'classnames';
import Image from 'next/image';
import styles from './alert-message.module.scss';
import RichtextModel from '../../../models/richtext';
import Richtext from '../richtext/Richtext';
import Media from '../../../models/media';

type Props = {
  message?: RichtextModel;
  backgroundColor?: string;
  arrow?: 'topleft' | 'topmid' | 'topright' | 'bottomleft';
  icon?: Media;
  closeIcon?: Media;
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
};

const AlertMessage = ({
  message,
  icon,
  closeIcon,
  onClose,
  backgroundColor,
  arrow
}: Props) => (
  <div
    role="alert"
    className={cx(styles.alert__message, {
      [styles[`alert__message--arrow-${arrow}`]]: arrow
    })}
    style={{
      ...(backgroundColor && {
        backgroundColor,
        '--arrowColor': backgroundColor
      })
    }}
  >
    {icon && (
      <div className={styles.alert__icon}>
        <Image
          alt={icon?.alt}
          src={icon?.src}
          layout="fixed"
          height={24}
          width={24}
        />
      </div>
    )}
    {message && (
      <Richtext
        data={message}
        customClasses={{
          container: styles['alert__text-container'],
          paragraph: styles.alert__text
        }}
      />
    )}
    {closeIcon && onClose && (
      <button
        type="button"
        className={styles.alert__close}
        onClick={onClose}
        name="close alert message"
      >
        <Image alt={closeIcon?.alt} src={closeIcon?.src} layout="fill" />
      </button>
    )}
  </div>
);

export default AlertMessage;
